export const downloadFile = (blob, fileName) => {
  const link = document.createElement('a')
  // create a blobURI pointing to our Blob
  link.href = URL.createObjectURL(
    new Blob([blob], {
      type: 'application/octetstream'
    })
  )
  link.download = fileName
  // some browser needs the anchor to be in the doc
  document.body.append(link)
  link.click()
  link.remove()
  // in case the Blob uses a lot of memory
  setTimeout(() => URL.revokeObjectURL(link.href), 7000)
}

export const openPdfWindow = blob => {
  var file = new Blob([blob], { type: 'application/pdf' })
  var fileURL = URL.createObjectURL(file)
  window.open(fileURL)
}

// download file
export const downFile = (blob, fileName) => {
  const link = document.createElement('a')
  const href = URL.createObjectURL(blob)
  // create a blobURI pointing to our Blob
  link.href = href
  link.download = fileName
  // some browser needs the anchor to be in the doc
  document.body.appendChild(link)
  link.click()
  link.remove()
  // in case the Blob uses a lot of memory
  setTimeout(() => {
    URL.revokeObjectURL(href)
  }, 1000)
}
export const getFileName = (res, defaultFileNm) => {
  const header = res.headers
  const ctd = header['content-disposition']
  let fileName = defaultFileNm
  if (ctd) {
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    var matches = filenameRegex.exec(ctd)
    if (matches != null && matches[1]) {
      fileName = matches[1].replace(/['"]/g, '')
    }
    fileName = decodeURIComponent(fileName)
  }
  return fileName
}
